(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always';
      this.mobileMenu = this.querySelector('header-drawer');
      this.currentScrollTop = 0;
      this.preventHide = false;
      this.preventReveal = false;

      this.headerCoords = {};
      this.calcHeaderCoords();

      this.onScrollHandler = this.onScroll.bind(this);
      this.enableScroll();
    }

    disconnectedCallback() {
      this.disableScroll();
    }

    calcHeaderCoords() {
      const clientRect = this.getBoundingClientRect();
      const pageYOffset = window.pageYOffset || document.documentElement.scrollTop;
      this.headerCoords.bottom = pageYOffset + clientRect.bottom;
      this.headerCoords.top = pageYOffset + clientRect.top;
    }

    onScroll(event) {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.headerIsAlwaysSticky) {
        if (scrollTop > this.header.offsetHeight + 1) {
          this.header.classList.add('shopify-section-header-sticky');
        }

        if (scrollTop < this.header.offsetHeight) {
          this.header.classList.remove('shopify-section-header-sticky');
        }
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventHide || (this.mobileMenu && this.mobileMenu.isOpen && window.innerWidth <= 1160)) {
          return;
        }
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerCoords.bottom) {
        if (this.preventReveal) {
          return;
        }
        requestAnimationFrame(this.reveal.bind(this));
      } else if (scrollTop <= this.headerCoords.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    enableScroll() {
      window.addEventListener('scroll', this.onScrollHandler, false);
    }

    disableScroll() {
      window.removeEventListener('scroll', this.onScrollHandler);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seji-cinematic-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const revealItems = document.querySelectorAll('.seji-reveal');
    if (!revealItems.length) return;
    if (!('IntersectionObserver' in window)) {
      revealItems.forEach((item) => item.classList.add('is-visible'));
      return;
    }
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["seji-the-cut-home"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const bindTabKeys = (buttons, activate) => {
      buttons.forEach((button, index) => {
        button.addEventListener('keydown', (event) => {
          if (!['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
          event.preventDefault();
          let next = index;
          if (event.key === 'ArrowRight') next = (index + 1) % buttons.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + buttons.length) % buttons.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = buttons.length - 1;
          buttons[next].focus();
          activate(Number(buttons[next].dataset.cutHeroTab ?? buttons[next].dataset.cutCurrent ?? next), buttons[next]);
        });
      });
    };

    const init = (root) => {
      if (!root || root.dataset.sejiCutReady === 'true') return;
      root.dataset.sejiCutReady = 'true';

      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const heroStage = root.querySelector('[data-cut-hero-stage]');
      const heroSlides = [...root.querySelectorAll('[data-cut-hero-slide]')];
      const heroDots = [...root.querySelectorAll('[data-cut-hero-dot]')];
      const heroToggle = root.querySelector('[data-cut-hero-toggle]');
      let heroIndex = 0;
      let heroTimer;
      let heroPaused = reducedMotion;
      const prepareHero = (index) => {
        const slide = heroSlides[(index + heroSlides.length) % heroSlides.length];
        slide?.querySelectorAll('[data-srcset]').forEach((source) => {
          source.srcset = source.dataset.srcset;
          source.removeAttribute('data-srcset');
        });
        const image = slide?.querySelector('img[data-src]');
        if (image) {
          image.src = image.dataset.src;
          image.removeAttribute('data-src');
        }
        return slide?.querySelector('img');
      };
      let heroRequest = 0;
      const activateHero = async (index) => {
        if (!heroSlides.length) return;
        const nextIndex = (index + heroSlides.length) % heroSlides.length;
        const request = ++heroRequest;
        const image = prepareHero(nextIndex);
        if (image && !image.complete) {
          try { await image.decode(); } catch (_) { return; }
        }
        if (request !== heroRequest) return;
        heroIndex = nextIndex;
        heroSlides.forEach((slide, slideIndex) => {
          const active = slideIndex === heroIndex;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.tabIndex = active ? 0 : -1;
          heroDots[slideIndex]?.setAttribute('aria-pressed', String(active));
        });
      };
      const stopHero = () => window.clearInterval(heroTimer);
      const startHero = () => {
        stopHero();
        if (heroPaused || heroSlides.length < 2 || document.hidden) return;
        heroTimer = window.setInterval(() => activateHero(heroIndex + 1), 5000);
      };
      const updateHeroToggle = () => {
        if (!heroToggle) return;
        heroToggle.textContent = heroPaused ? root.dataset.cutPlay : root.dataset.cutPause;
        heroToggle.setAttribute('aria-label', heroPaused ? root.dataset.cutPlaySlideshow : root.dataset.cutPauseSlideshow);
      };
      heroDots.forEach((dot, index) => dot.addEventListener('click', () => {
        activateHero(index);
        startHero();
      }));
      heroToggle?.addEventListener('click', () => {
        heroPaused = !heroPaused;
        updateHeroToggle();
        startHero();
      });
      heroStage?.addEventListener('focusin', (event) => {
        if (event.target.closest('a')) stopHero();
      });
      heroStage?.addEventListener('focusout', (event) => {
        if (!heroStage.contains(event.relatedTarget)) startHero();
      });
      document.addEventListener('visibilitychange', () => document.hidden ? stopHero() : startHero());
      document.addEventListener('shopify:section:unload', (event) => {
        if (event.target.contains(root)) stopHero();
      });
      activateHero(0);
      updateHeroToggle();
      startHero();
      const firstHeroImage = heroSlides[0]?.querySelector('img');
      const warmNextHero = () => prepareHero(1);
      if (firstHeroImage?.complete) warmNextHero();
      else firstHeroImage?.addEventListener('load', warmNextHero, { once: true });

      const currentControls = [...root.querySelectorAll('[data-cut-current]')];
      const currentFrames = [...root.querySelectorAll('[data-cut-current-frame]')];
      const nowPlaying = root.querySelector('[data-cut-now-playing]');
      const currentNames = [
        root.dataset.cutNeonName,
        root.dataset.cutTealName,
        root.dataset.cutDaylightName,
        root.dataset.cutAmberName
      ];
      const activateCurrent = (index) => {
        currentControls.forEach((control) => {
          const active = Number(control.dataset.cutCurrent) === index;
          control.classList.toggle('is-active', active);
          if (control.getAttribute('role') === 'tab') {
            control.setAttribute('aria-selected', String(active));
            control.tabIndex = active ? 0 : -1;
          }
        });
        currentFrames.forEach((frame, frameIndex) => {
          const active = frameIndex === index;
          frame.classList.toggle('is-active', active);
          frame.setAttribute('aria-hidden', String(!active));
          frame.tabIndex = active ? 0 : -1;
        });
        if (nowPlaying) nowPlaying.textContent = currentNames[index] || currentNames[0];
      };
      currentControls.forEach((control) => control.addEventListener('click', () => activateCurrent(Number(control.dataset.cutCurrent))));
      bindTabKeys(currentControls.filter((control) => control.getAttribute('role') === 'tab'), activateCurrent);

      const moodTabs = [...root.querySelectorAll('[data-cut-mood]')];
      const leftImage = root.querySelector('[data-cut-left-image]');
      const rightImage = root.querySelector('[data-cut-right-image]');
      const leftLink = root.querySelector('[data-cut-left-link]');
      const rightLink = root.querySelector('[data-cut-right-link]');
      const leftCaption = root.querySelector('[data-cut-left-caption]');
      const rightCaption = root.querySelector('[data-cut-right-caption]');
      const activateMood = (index) => {
        const tab = moodTabs[index];
        if (!tab) return;
        moodTabs.forEach((item, itemIndex) => {
          const active = itemIndex === index;
          item.classList.toggle('is-active', active);
          item.setAttribute('aria-selected', String(active));
          item.tabIndex = active ? 0 : -1;
        });
        if (leftImage) {
          leftImage.src = tab.dataset.leftSrc;
          leftImage.alt = tab.dataset.leftAlt;
        }
        if (rightImage) {
          rightImage.src = tab.dataset.rightSrc;
          rightImage.alt = tab.dataset.rightAlt;
        }
        if (leftLink) leftLink.href = tab.dataset.leftUrl;
        if (rightLink) rightLink.href = tab.dataset.rightUrl;
        if (leftCaption) {
          leftCaption.textContent = tab.dataset.leftLabel;
          leftCaption.href = tab.dataset.leftUrl;
        }
        if (rightCaption) {
          rightCaption.textContent = tab.dataset.rightLabel;
          rightCaption.href = tab.dataset.rightUrl;
        }
      };
      moodTabs.forEach((tab, index) => tab.addEventListener('click', () => activateMood(index)));
      bindTabKeys(moodTabs, activateMood);

      const splitStage = root.querySelector('[data-cut-split-stage]');
      const splitRange = root.querySelector('[data-cut-split-range]');
      if (splitStage && splitRange) {
        splitRange.addEventListener('input', () => {
          const value = Number(splitRange.value);
          splitStage.style.setProperty('--split', `${value}%`);
          splitRange.setAttribute('aria-valuetext', `${value}% left artwork, ${100 - value}% right artwork`);
        });
      }

      const categoryTabs = [...root.querySelectorAll('[data-cut-category-tab]')];
      const categoryPanels = [...root.querySelectorAll('[data-cut-category-panel]')];
      const activateCategory = (index) => {
        categoryTabs.forEach((tab, tabIndex) => {
          const active = tabIndex === index;
          tab.classList.toggle('is-active', active);
          tab.setAttribute('aria-selected', String(active));
          tab.tabIndex = active ? 0 : -1;
        });
        categoryPanels.forEach((panel, panelIndex) => {
          const active = panelIndex === index;
          panel.classList.toggle('is-active', active);
          panel.hidden = !active;
        });
      };
      categoryTabs.forEach((tab, index) => tab.addEventListener('click', () => activateCategory(index)));
      bindTabKeys(categoryTabs, activateCategory);

      categoryPanels.forEach((panel) => {
        const products = [...panel.querySelectorAll('[data-cut-category-product]')];
        const selectors = products.map((product) => product.querySelector('[data-cut-category-select]'));
        const featureLink = panel.querySelector('[data-cut-category-feature-link]');
        const featureImage = panel.querySelector('.seji-cut__category-feature-image');
        const counter = panel.querySelector('[data-cut-category-counter]');
        const previous = panel.querySelector('[data-cut-category-previous]');
        const next = panel.querySelector('[data-cut-category-next]');
        let productIndex = 0;

        const selectProduct = (index) => {
          if (!products.length) return;
          productIndex = (index + products.length) % products.length;
          products.forEach((product, itemIndex) => {
            const active = itemIndex === productIndex;
            product.classList.toggle('is-active', active);
            selectors[itemIndex]?.setAttribute('aria-pressed', String(active));
          });
          const selected = selectors[productIndex];
          if (selected && featureImage) {
            featureImage.src = selected.dataset.productImage;
            featureImage.srcset = '';
            featureImage.alt = selected.dataset.productAlt;
          }
          if (selected && featureLink) featureLink.href = selected.dataset.productUrl;
          if (counter) {
            const current = String(productIndex + 1).padStart(2, '0');
            const total = String(products.length).padStart(2, '0');
            counter.textContent = `${current} / ${total}`;
          }
        };

        selectors.forEach((selector, index) => selector?.addEventListener('click', () => selectProduct(index)));
        previous?.addEventListener('click', () => selectProduct(productIndex - 1));
        next?.addEventListener('click', () => selectProduct(productIndex + 1));
        selectProduct(0);
      });
      const initialCategoryIndex = categoryTabs.findIndex((tab) => tab.classList.contains('is-active'));
      activateCategory(initialCategoryIndex >= 0 ? initialCategoryIndex : 0);

      const reveals = [...root.querySelectorAll('.seji-cut__reveal')];
      if (reducedMotion || !('IntersectionObserver' in window)) {
        reveals.forEach((element) => element.classList.add('is-visible'));
      } else {
        const observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          });
        }, { threshold: 0.12 });
        reveals.forEach((element) => observer.observe(element));
      }
    };

    const initAll = () => document.querySelectorAll('[data-seji-cut]').forEach(init);
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll, { once: true });
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', (event) => init(event.target.querySelector('[data-seji-cut]')));
  })();

  } catch(e) { console.error(e); }
})();
})();
